import { useState } from "react";
import { PageShell } from "@/components/mai/PageShell";
import { DICTIONARY } from "@/content/dictionary";
import { Input } from "@/components/ui/input";
import { MagnifyingGlass } from "@phosphor-icons/react";

export default function DictionaryPage() {
  const [q, setQ] = useState("");
  const filtered = DICTIONARY.filter((d) =>
    !q.trim() || (d.term + " " + d.def).toLowerCase().includes(q.toLowerCase()));

  return (
    <PageShell pageId="platform" overline="Usability · Consistent Terminology" title="Data Dictionary">
      <div className="max-w-4xl space-y-4">
        <p className="text-xs text-slate-500 max-w-2xl leading-relaxed">
          Every key term and calculation used across MAI Matrix™, in plain language — so every analyst and consultant reads the same score the same way.
        </p>
        <div className="relative max-w-md">
          <MagnifyingGlass size={14} className="absolute left-3 top-1/2 -translate-y-1/2 text-slate-400" />
          <Input data-testid="dictionary-search" value={q} onChange={(e) => setQ(e.target.value)}
            placeholder="Search terms… e.g. leverage, reuse score, bucket" className="pl-9 bg-white" />
        </div>
        <div data-testid="dictionary-list" className="bg-white border border-slate-200 divide-y divide-slate-100">
          {filtered.length === 0 ? (
            <p className="px-5 py-10 text-center text-xs text-slate-400">No terms match "{q}".</p>
          ) : filtered.map((d) => (
            <div key={d.term} data-testid={`dictionary-term-${d.term.toLowerCase().replace(/[^a-z0-9]+/g, "-")}`} className="px-5 py-3.5">
              <p className="text-sm font-bold text-slate-900">{d.term}</p>
              <p className="text-xs text-slate-600 mt-1 leading-relaxed">{d.def}</p>
            </div>
          ))}
        </div>
      </div>
    </PageShell>
  );
}
